import type { Currency } from "@/api/types";
import "./currency-badge.css";

export function CurrencyBadge({ ccy }: { ccy: Currency | null | undefined }) {
  if (!ccy) {
    return (
      <span className="wp-ccybadge wp-ccybadge--unknown" aria-label="Валюта ще не визначена">
        ?
      </span>
    );
  }
  return (
    <span className="wp-ccybadge" aria-label={`Валюта чеку: ${ccy}`}>
      {ccy}
    </span>
  );
}
